var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 127",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 39.255l45.514.404 16.385 24.072 15.576-24.88 46.525.606-16.992 22.049v50.369l-44.502 13.553-46.323-14.969v-48.75L2 39.254z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.183 61.708l45.716 2.023.607 61.696",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.183 61.708l45.716 2.023.607 61.696M63.9 63.73l45.109-2.225M15.554 19.026l11.53 9.71M114.471 19.026l-11.733 9.103M32.95 6.889l15.576 18.003M64.708-1l.607 26.5M94.444 4.866l-11.732 19.42",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

export default SvgCartThin;